import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { NgForm, NgModel } from '@angular/forms'
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component'
import { UtilsService } from 'src/app/utils/utils.service'
import Swal from 'sweetalert2'
import { GrupoEquipamento } from 'src/app/classes/GrupoEquipamento'
import { GrupoEquipamentoService } from 'src/app/services/grupo-equipamento.service'
@Component({
  selector: 'app-forms-grupo-equipamento',
  templateUrl: './forms-grupo-equipamento.component.html',
  styleUrls: ['./forms-grupo-equipamento.component.scss']
})
export class FormsGrupoEquipamentoComponent implements OnInit {

  @ViewChild('Modal', { static: false }) modal: UiModalComponent
  @ViewChild('formulario', { static: false }) formulario!: NgForm;
  @Output() finalizarSave: EventEmitter<void> = new EventEmitter()
  @Output() change: EventEmitter<boolean | void> = new EventEmitter()
  @Input() lista: GrupoEquipamento[] = []
  @Input() isSuper: boolean = false


  isSubmit: boolean = false
  item: GrupoEquipamento = new GrupoEquipamento()
  carregando: boolean = false
  int32MaxValue = 2147483647;

  constructor(
    private utils: UtilsService,
    private grupoEquipamentoService: GrupoEquipamentoService,
  ) {}

  ngOnInit() {}

  abrirModal(grupo: GrupoEquipamento = null): void {
    if(grupo === null && !this.utils.verificarPermissaoUsuario('IncluirGrupoEquipamento'))
      return;
    if(grupo !== null && !this.utils.verificarPermissaoUsuario('EditarGrupoEquipamento'))  
      return;
    if (grupo !== null){
      this.item = grupo
      this.change.emit(true)
    }
    else
      this.item = new GrupoEquipamento()

    this.modal.show()
  }

  fecharModal(): void {
    this.modal.hide()
    this.isSubmit = false
    this.formulario.resetForm();
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
);
  }

  changeItem(): void{
    this.change.emit()
  }

  save(): void {
    this.carregando = true

    if (!this.validarForm()) return

    this.item.UsuarioCadastro = null
    this.item.UsuarioAlteracao = null
    if (this.item.Id) {
      this.grupoEquipamentoService
        .putGrupoEquipamento(this.item.Id, this.item)
        .subscribe(
          (res) => {
            this.finalizarSaveRequestSuccess(
              'Grupo equipamento alterado com sucesso!',
            )
          },
          (err) => {
            this.finalizarRequestError(err)
          },
        )
    } else {
      this.grupoEquipamentoService.postGrupoEquipamento(this.item).subscribe(
        (res) => {
          this.finalizarSaveRequestSuccess(
            'Grupo equipamento cadastrado com sucesso!',
          )
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    }
  }

    confirmExcluir(grupo: GrupoEquipamento): void{
      if(!this.utils.verificarPermissaoUsuario('ExcluirGrupoEquipamento'))
        return;
      Swal.fire({
        title: 'Você tem certeza desta ação?',
        text:
          'Deseja excluir este grupo de equipamento?. Essa ação é irreversível!',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Excluir Grupo Equipamento',
      }).then((response) => {
        if (!response.dismiss) {
          this.excluir(grupo);
        }
      })
    }

  excluir(grupo: GrupoEquipamento): void{
    this.carregando = true;

    this.grupoEquipamentoService.deleteGrupoEquipamento(grupo.Id).subscribe(
      res => {
        this.utils.handleSuccess("Grupo equipamento excluído com sucesso!")
        this.carregando = false;
        this.finalizarSave.emit()
      },
      err => {
        this.utils.getErro(err)
        this.carregando = false;
      }
    )
  }

  validarForm(): boolean {
    if (this.formulario.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    return true
  }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit()
    this.fecharModal()
  }

  finalizarRequestError(error: any): void {
    this.utils.getErro(error)
    this.carregando = false
  }
}
